export function loopFilter() {
  const filterButton = document.querySelector('.loop-filter__button');
  const filterBox = document.querySelector('.loop-filter__box');
  const iconFilter = document.querySelector('.icon-filter');
  const iconClose = document.querySelector('.icon-close');

  if (filterButton && filterBox && iconFilter && iconClose) {
    filterButton.addEventListener('click', () => {
      filterBox.classList.toggle('loop-filter__box--open');
      iconFilter.classList.toggle('d-none');
      iconClose.classList.toggle('d-none');
    });
  }

  document.addEventListener('click', (event) => {
    if (
      filterBox &&
      filterButton &&
      !filterBox.contains(event.target) &&
      !filterButton.contains(event.target)
    ) {
      filterBox.classList.remove('loop-filter__box--open');
      iconFilter.classList.remove('d-none');
      iconClose.classList.add('d-none');

      const tagSearchInput = document.getElementById('tag-search');
      if (tagSearchInput) {
        tagSearchInput.value = '';
      }
    }
  });
}
